import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HeaderSignalService {
    private _headerEvent = signal<string>(''); // Reactive signal for event sharing

    // Getter for other components to access the signal
    get headerEvent(): Signal<string> {
        return this._headerEvent;
    }

    // Method to emit an event
    emitEvent(eventData: string): void {
        this._headerEvent.set(eventData); // Update the signal's value
    }

    // Optional convenience method to close the menu
    closeMenu(): void {
        this.emitEvent('menuClose');
    }
}
